import Helpers from './helpers';
import Ping from './ping';

export default class DeleteMember {
	constructor({ elements }) {
		elements.forEach((el) => {
			this.urlBase = '/umbraco/api/professionalApi/';
			this.apiEndpointSet = el?.dataset?.apiEndpointSet;
			this.antiForgeryToken = el?.dataset?.antiForgeryToken;
			el.addEventListener('submit', (e) => {
				e.preventDefault();
				Helpers.disableAllButtons();
				this.displayCheckPopup(e, el);
			});
		});
	}

	displayCheckPopup(e, form) {
		e.preventDefault();
		window.dispatchEvent(
			new CustomEvent('lightbox-show-by-template-id', {
				detail: {
					templateId: 'popUpDeleteProfessional',
				},
			})
		);
		document.getElementById('doubleCheckCancel').addEventListener('click', () => {
			e.preventDefault();
			Helpers.enableAllButtons();
			window.dispatchEvent(new CustomEvent('lightbox-close'));
		});
		document.getElementById('doubleCheckSubmit').addEventListener('click', () => {
			e.preventDefault();
			this.deleteMember(form);
			window.dispatchEvent(new CustomEvent('lightbox-close'));
		});
	}

	async deleteMember(form) {
		try {
			const response = await fetch(
				`${this.urlBase}${this.apiEndpointSet}?professionalKey=${form.ProfessionalKey.value}`,
				{
					headers: {
						'Content-Type': 'application/json',
						Culture: document.documentElement.lang,
						RequestVerificationToken: this.antiForgeryToken,
					},
					method: 'POST',
				}
			);

			if (!response.ok) {
				throw new Error();
			}

			const data = await response.json();

			if (data != null && data?.redirectUrl) {
				window.location = data?.redirectUrl;
			}
		} catch (data) {
			if (data != null) {
				Ping.createSadPing(data?.ping?.pingHeading, data?.ping?.pingBody, data?.ping?.pingEmotion);
			}
		} finally {
			Helpers.enableAllButtons();
		}
	}
}
